import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom'
import Layout from './app/Layout'
import Home from './features/home/Home'
import Game from './features/game/Game'
import LevelSelection from './features/level/LevelSelection'
import About from './features/about/About'

import './App.css';

const root = process.env.PUBLIC_URL

function App() {
  return (
    <Router>
      <Layout>
        <Switch>
          <Route exact path={`${root}/`} component={Home} />
          <Route exact path={`${root}/game/:id`} component={Game} />
          <Route exact path={`${root}/level`} component={LevelSelection} />
          <Route exact path={`${root}/about`} component={About} />
          <Redirect to={`${root}/`} />
        </Switch>
      </Layout>
    </Router>
  );
}

export default App;
